import isNil from 'lodash-es/isNil';
import sumBy from 'lodash-es/sumBy';
import React, { useState } from 'react';
import { Button, ModalBox, Option, ProductsList, useModalContext } from '@fourthwall/components';
import * as S from './OrderVariantsModal.styled';
export const OrderVariantsModal = ({ offer, replacements, onConfirm }) => {
    const { close } = useModalContext();
    const variantTypes = offer.offer.variantTypes;
    const [selectedVariantId, setSelectedVariantId] = useState(offer.variant.id);
    const hasVariants = !!variantTypes?.length;
    const variants = offer.offer.variants
        .filter((variant) => variant.id === selectedVariantId || variant.status !== 'ARCHIVED')
        .map((variant) => {
        const isReplacingFrom = (replacement) => replacement.from === variant.id;
        const isReplacingTo = (replacement) => replacement.to === variant.id;
        const additionalQuantity = sumBy(replacements.filter(isReplacingFrom), 'quantity');
        const selectedQuantity = sumBy(replacements.filter(isReplacingTo), 'quantity');
        const currentQuantity = !isNil(variant.quantity)
            ? variant.quantity + additionalQuantity - selectedQuantity
            : variant.quantity;
        return {
            id: variant.id,
            name: variant.name,
            description: variant.attributesDescription,
            quantity: variant.quantity,
            disabled: !isNil(currentQuantity) && currentQuantity < offer.quantity,
            selected: selectedVariantId === variant.id,
        };
    });
    const selectedVariant = offer.offer.variants?.find((variant) => variant.id === selectedVariantId);
    const currentVariant = {
        id: offer.variant.id,
        name: offer.variant.name,
        description: offer.variant.attributesDescription,
        // @ts-ignore
        image: offer.offer.thumbnailImage,
    };
    const disabled = !hasVariants || !selectedVariant;
    const handleConfirm = () => {
        close();
        if (!selectedVariant) {
            return;
        }
        onConfirm({
            ...offer,
            price: selectedVariant.price,
            variantId: selectedVariant.id,
            variant: {
                ...selectedVariant,
                images: selectedVariant.images.map((imageId) => offer.offer.images.find((offerImage) => offerImage.id === imageId)),
            },
        });
    };
    const renderVariants = () => {
        if (!hasVariants) {
            return (React.createElement(S.EmptyVariantsNotice, null, "This offer doesn't have set up variants that can use as a replacement."));
        }
        return (React.createElement(S.VariantsContainer, null, variants?.map((variant) => (React.createElement(S.VariantContainer, { key: variant.id },
            React.createElement(Option, { checked: variant.selected, disabled: variant.disabled, label: React.createElement(S.OptionLabel, { disabled: Boolean(variant.disabled) },
                    React.createElement("div", null, variant.description),
                    React.createElement("div", null, isNil(variant.quantity) ? 'Unlimited' : `${variant.quantity} in stock`)), onChange: () => setSelectedVariantId(variant.id) }))))));
    };
    return (React.createElement(ModalBox, { title: "Edit variant", buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: close }),
            React.createElement(Button, { label: "Update", appearance: "primary", disabled: disabled, onClick: handleConfirm }),
        ], onClose: close },
        React.createElement(S.ProductSummaryContainer, null,
            React.createElement(ProductsList, null,
                React.createElement(ProductsList.Item, { name: currentVariant.name, description: currentVariant.description, image: currentVariant.image }))),
        renderVariants()));
};
